// assets/custom.js
document.addEventListener('DOMContentLoaded', function() {
  console.log('📢 custom.js loaded');

  // ShopifyAnalytics からページ情報を取ってくる
  var pageType = ShopifyAnalytics?.meta?.page?.pageType;         // ex. 'product'
  var handle   = ShopifyAnalytics?.meta?.product?.handle || ''; // 商品のハンドル名

  console.log('PageType:', pageType, 'handle:', handle);

  // 「商品ページかつ handle が取れていれば」だけ実行
  if (pageType === 'product' && handle) {
    fetch('/products/' + handle + '.json')
      .then(function(res){
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function(data){
        console.log('✅ product JSON:', data);
        // ↓ ここに必要な処理を書いていってください
      })
      .catch(function(err){
        console.warn('⚠️ 商品JSON取得エラー:', err);
      });
  }
});
